import { motion, AnimatePresence } from "motion/react";
import { testimonialTextVariants } from "@/lib/animations";
import { QuoteLeft } from "@/components/icons/QuoteLeft";
import { ArrowRight2 } from "@/components/icons/ArrowRight2";
import { ArrowLeft2 } from "@/components/icons/ArrowLeft2";
import type { TestimonialCardProps } from "../types";

export function TestimonialCard({
  id,
  bgImageUrl,
  message,
  onNext,
  onPrev,
  direction,
}: TestimonialCardProps) {
  return (
    <div className="relative flex h-[calc(100vh-80px)] items-end justify-end overflow-hidden px-5 md:px-6 lg:px-10">
      <AnimatePresence initial={false}>
        <motion.div
          key={id}
          className="absolute inset-0 z-0 bg-cover bg-no-repeat"
          style={{
            backgroundPosition: "center 46%",
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #052404 100%), url(${bgImageUrl})`,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        />
      </AnimatePresence>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-end pb-8 md:pb-10 lg:pb-16">
        <div className="relative max-w-[620px]">
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={id}
              custom={direction}
              variants={testimonialTextVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.4, ease: "easeOut" }}
              className="flex items-start gap-2 text-xl font-medium tracking-copy text-white lg:text-[28px] lg:leading-[40px]"
            >
              <QuoteLeft className="-mt-2 opacity-25 md:-mt-6 md:size-14 lg:-mt-8 lg:size-20" />
              {message}
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="mt-6 flex items-center justify-end gap-4">
          <button
            onClick={onPrev}
            aria-label="Previous testimonial"
            className="transition-opacity hover:opacity-50"
          >
            <ArrowLeft2 className="text-white" />
          </button>
          <button
            onClick={onNext}
            aria-label="Next testimonial"
            className="transition-opacity hover:opacity-50"
          >
            <ArrowRight2 className="text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}
